import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MentionsLegales from "../pages/mentions-legales/page";
import Confidentialite from "../pages/confidentialite/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/confidentialite",
    element: <Confidentialite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
